var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.396,
    height: 29.433,
    viewBox: "0 0 27.396 29.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Water_for_Wildlife",
    "data-name": "Water for Wildlife",
    transform: "translate(0.501 1.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M9.635,27.793h0c-.1,0-.195,0-.291,0A9.642,9.642,0,0,1,0,17.876c0-3.612,2.156-6.584,4.653-10.024A53.137,53.137,0,0,0,9.635,0a51.69,51.69,0,0,0,5.049,8.01c2.453,3.375,4.571,6.291,4.571,9.866.005.19.005.384,0,.574a9.63,9.63,0,0,1-9.621,9.343Zm-7.25-10.52a8.044,8.044,0,0,0,7.792,8.271l.053-1.8a6.243,6.243,0,0,1-6.045-6.419l-1.8-.053Z",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M128.2,0c-1.685,3.422-4.213,5.215-4.213,7.824a4.213,4.213,0,1,0,8.426.013V7.824c0-2.609-2.529-4.347-4.213-7.824",
    transform: "translate(-105.513 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.c81e81a0d8c20fffeea9d85c31531102.svg";
export { ForwardRef as ReactComponent };